<script setup lang="ts">
// ⚠️ Could not locate NuxtLink.vue
const router = useRouter()
const props = withDefaults(defineProps<{
	title: string
	description: string
	image: string
	path: string
}>(), {
	title: '',
	description: "",
	image: '/images/1.jpeg',
	path: '/'
})


function redirect(path: string) {
	router.push(path);
}
</script>

<template>
	<Frame @click="`/products/${path}`" class="sec-product-category-card flex gmb-1 min-h-230px gp-1" w="max-w-96% mx-auto grid grid-cols-[1fr] tm:grid-cols-[0.5fr_1fr] g-1 tm: g-2 ">
		<div class="card-image flex items-center justify-center">
			<div class="card-image-inner max-w-200px">
				<img class="transition-all duration-500 max-w-200px;" :src="image" :alt="title" />
			</div>
		</div>
		<Frame class="card-content flex-1" w="grid g-1 max-w-92% tm:max-w-80% ds:max-w-100% mx-auto gpb-1">
			<div class="title fs-2.5! ds:fs-35! dm:fs-35! glh-1.5!">
				{{ title }}
			</div>
			<div class="description glh-1.2!">{{ description }}</div>
			<div class="card-action">
				<NuxtLink :to="`/products/${path}`" class="card-link">
					<span class="label uppercase text-gray-400">Learn more</span>
					<i class="i-mdi:arrow-right text-base flex" />
				</NuxtLink>
			</div>
		</Frame>
	</Frame>
</template>

<style lang="scss" scoped>
.sec-product-category-card {
	display: flex;
	overflow: hidden;
	transition: all 300ms ease-in-out, transform 0s ease-in-out;
	background: white;
	border: 0;
	border-radius: 0.75rem;

	@apply shadow-lg;

	width: 100%;
	max-width: 800px;

	cursor: pointer;


	.card-image {
		/* @apply flex-none w-2/5 h-full overflow-hidden; */
		transition: transform 0.5s ease-in-out;
		position: relative;
		/* background: red; */
		width: 100%;
		flex: 1;

		display: flex;
		align-items: flex-start;
		justify-content: center;

		.card-image-inner {
			width: 100%;
			position: relative;
			overflow: hidden;
			border-radius: 100%;
			aspect-ratio: 1/1;
			margin-top: gr(1);

			img {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				object-fit: cover;
			}
		}

	}

	/* .card-image img { */
	/*     @apply w-full h-full object-cover; */
	/*     transition: transform 0.5s ease-in-out; */
	/*     position: absolute; */
	/* } */

	.card-content {

		position: relative;
		display: grid;
		transition: all 0.3s ease-in-out;


		.title {
			font-weight: 400;
			font-size: fs(2);
			font-family: var(--quicksand);
			line-height: gr(1.1);
		}

		.description {
			color: var(--body-primary);
		}

		.card-action {
			@apply mt-4 flex items-center justify-end;

			transition: all 0.5s;

			position: absolute;
			bottom: 0;
			left: 0;

			transform: translateY(50%);
			opacity: 0;

			a {

				text-transform: uppercase;
        display:flex;
        align-items: center;
        position: relative;
        transition: all 0.2s ease-in-out;

				span {
					font-size: fs(-1);
					color: var(--blue-700);
				}

				i {
          margin-left: gr(0.5);
          font-size: fs(-1.5);
          transition: all 0.2s ease-in-out;
          color: var(--base-600);
					opacity: 0;
					transform: translateX(-100%);
        }
			}
		}

		@include mq($from: t) {
			padding: gr(1.25) gr(1.5) gr(1.25) gr(0);
		}
	}

	.card-title {
		font-size: fs(1.5);
		font-weight: 400;
		margin: 0 0 gr(1) 0;
		line-height: gr(1.25);


		@apply tracking-wide;

		color: var(--heading-primary);
		line-height: gr(1.1);
	}

	.card-description {
		color: var(--base-600);
		margin-bottom: 0;
	}



	.card-link {
		@apply text-black no-underline;
	}

	.icon-arrow {
		@apply w-4 h-4 bg-black inline-block;
		-webkit-mask: url('/path/to/arrow-icon.svg') no-repeat center;
		mask: url('/path/to/arrow-icon.svg') no-repeat center;
		-webkit-mask-size: cover;
		mask-size: cover;
	}

	/* Hover effect for image zoom out */
	.card:hover .card-image img {
		transform: scale(1.1);
	}

	@include mq($until: 600px) {
		// @apply flex-col h-auto;

		.card-image {
			// @apply w-full h-48;
		}

		.card-content {
			// @apply w-full;

			.card-action {
				a {
					color: var(--base-650);
				}
			}
		}
	}

	&:hover {

		@include mq($from: t) {
			@apply shadow-xl;
		}

		.card-image {
			img {
				transform: scale(1.05)
			}
		}

		.card-content {

			transform: translateY(gr(-1));

			.card-action {
				transform: translateY(50%);
				opacity: 1;
				a {
          span {
            color: var(--blue-700);
          }

          i {
            opacity: 1;
            transform: translateX(0) translateY(-1px);
          }


          &:hover {
            
            &:active {
              i {
                transform: translateX(0) translateY(-1px);
              }
            }
          }
        }
			}

		}

		&:active {
			transform: translateY(1px);
		}
	}
}
</style>